<template>
  <div id="app">
    <v-fab-transition>
      <v-btn
        color="error"
        fab
        large
        dark
        class="v-btn--open-dialog"
        @click="parametersDialog = !parametersDialog"
        style="z-index: 100"
      >
        <v-icon v-if="!parametersDialog">keyboard_arrow_right</v-icon>
        <v-icon v-if="parametersDialog">keyboard_arrow_left</v-icon>
      </v-btn>
    </v-fab-transition>

    <v-dialog v-model="parametersDialog" max-width="600px">
      <v-card class="mx-auto" max-width="1000">
        <v-card-text>
          <v-form ref="form">
            <v-row>
              <v-col cols="12" sm="6">
                <v-icon
                  class="float-left py-4 pr-2 d-none d-sm-flex"
                  color="primary"
                  >person</v-icon
                >
                <v-text-field
                  v-model="firstname"
                  label="First name"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="lastname"
                  label="Last name"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="12">
                <v-icon
                  class="float-left py-4 pr-2 d-none d-sm-flex"
                  color="primary"
                  >email</v-icon
                >
                <v-text-field v-model="email" label="Email"></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="12">
                <v-icon
                  class="float-left py-4 pr-2 d-none d-sm-flex"
                  color="primary"
                  >settings_cell</v-icon
                >
                <v-text-field
                  v-model="mobile"
                  label="Mobile number"
                  v-mask="'###########'"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-card-actions>
              <v-btn
                @click="parametersDialog = !parametersDialog"
                color="red"
                dark
                >Close</v-btn
              >
              <div class="flex-grow-1"></div>
              <v-btn @click="bookingSearch()" color="info">Search</v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-container>
      <Header />
      <v-overlay :value="loader">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <div class="text-center">
        <v-btn
          class="my-2 text-center"
          fab
          dark
          large
          color="blue darken-3"
          @click="previous"
        >
          <v-icon dark> keyboard_arrow_up </v-icon>
        </v-btn>
      </div>

      <Booking :eventData="events" v-if="events.length > 0" />
      <div class="text-center">
        <v-btn
          class="my-2 text-center"
          fab
          dark
          large
          color="blue darken-3"
          @click="next"
        >
          <v-icon dark> keyboard_arrow_down </v-icon>
        </v-btn>
      </div>
    </v-container>
  </div>
</template>

<script>
import { Auth } from "aws-amplify";
import Header from "../components/Header.vue";
import Booking from "../components/Booking.vue";
import { API, graphqlOperation } from "aws-amplify";
import * as queries from "./../graphql/queries";
import moment from "moment";
export default {
  components: {
    Header,
    Booking,
  },
  data() {
    return {
      loader: false,
      events: [],
      nextToken: null,
      from: moment().subtract(1, "day"),
      to: moment().add(2, "month"),
      parametersDialog: false,
      firstname: null,
      lastname: null,
      email: null,
      dob: null,
      mobile: null,
    };
  },
  created() {
    this.getEvents();
  },
  methods: {
    async getEvents() {
      this.loader = true;
      this.events = [];
      this.nextToken = null;
      let events = await this.nextRecord();
      while (this.nextToken !== null) {
        let nextEvents = await this.nextRecord();
        events.push(...nextEvents);
      }
      this.events = events;
      this.loader = false;
    },
    async previous() {
      (this.from = this.from.subtract(2, "month")),
        (this.to = this.to.subtract(2, "month")),
        this.getEvents();
    },
    async next() {
      (this.from = this.from.add(2, "month")),
        (this.to = this.to.add(2, "month")),
        this.getEvents();
    },
    async getEventById(id) {
      const getEvent = /* GraphQL */ `
        query GetEvent($id: ID!) {
          getEvent(id: $id) {
            eventCompany {
              id
              name
            }
            id
            name
            code
            status
            type
            iCalendar
            attendance
            eventLocation {
              items {
                id
                addressLine1
                postcode
                town
                createdAt
                eventSlotGroup {
                  items {
                    id
                    room
                    createdAt
                    date
                    capacity
                    eventSlot {
                      items {
                        id
                        length
                        time
                        type
                        booked
                        eventBooking {
                          items {
                            id
                            firstname
                            lastname
                            email
                            mobile
                            dob
                            attendance
                            customData
                            twentyFourHourReminder
                            isDeleted
                          }
                        }
                      }
                    }
                  }
                }
              }
              nextToken
            }
            eventCollectUserData {
              items {
                id
                label
                validation
                fieldType
                createdAt
                isDeleted
                eventCollectUserDataOptions {
                  items {
                    id
                    options
                  }
                }
              }
              nextToken
            }
          }
        }
      `;
      const { data: events } = await API.graphql(
        graphqlOperation(getEvent, {
          id: id,
        })
      );
      return events.getEvent;
    },
    async nextRecord() {
      const listEvents = /* GraphQL */ `
        query ListEvents(
          $filter: ModelEventFilterInput
          $limit: Int
          $nextToken: String
          $dateFrom: String
          $dateTo: String
        ) {
          listEvents(filter: $filter, limit: $limit, nextToken: $nextToken) {
            items {
              eventCompany {
                id
                name
              }
              id
              name
              code
              status
              type
              iCalendar
              attendance
              eventLocation(filter: { isDeleted: { eq: 0 } }) {
                items {
                  id
                  addressLine1
                  postcode
                  town
                  createdAt
                  eventSlotGroup(
                    limit: 1000
                    filter: {
                      isDeleted: { eq: 0 }
                      date: { between: [$dateFrom, $dateTo] }
                    }
                  ) {
                    items {
                      id
                      room
                      createdAt
                      date
                      capacity
                      eventSlot(limit: 1000) {
                        items {
                          id
                          length
                          time
                          type
                          booked
                          eventBooking(
                            limit: 1000
                            filter: { isDeleted: { eq: 0 } }
                          ) {
                            items {
                              id
                              firstname
                              lastname
                              email
                              mobile
                              dob
                              attendance
                              marketing
                              marketingEmail
                              marketingText
                              customData
                              twentyFourHourReminder
                              isDeleted
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
              eventCollectUserData {
                items {
                  id
                  label
                  validation
                  fieldType
                  createdAt
                  isDeleted
                  eventCollectUserDataOptions {
                    items {
                      id
                      options
                    }
                  }
                }
              }
            }
            nextToken
          }
        }
      `;
      const { data: events } = await API.graphql(
        graphqlOperation(listEvents, {
          filter: { isDeleted: { eq: 0 } },
          nextToken: this.nextToken,
          dateFrom: this.from,
          dateTo: this.to,
        })
      );
      this.nextToken = events.listEvents.nextToken;
      return events.listEvents.items;
    },
    async bookingSearch() {
      const that = this;
      this.parametersDialog = false;
      this.loader = true;
      this.events = [];
      if (this.firstname || this.lastname || this.email || this.mobile) {
        let eventIds = [];
        // Firstname, lastname and email (perfect search)
        if (this.firstname && this.lastname && this.email) {
          // console.log(`${this.firstname} ${this.lastname} ${this.email}`);
          let e = await this.searchBookingBySearchField(
            `${this.firstname} ${this.lastname} ${this.email}`
          );
          eventIds.push(...e);
        } else if (this.firstname || this.lastname || this.email) {
          // Firstname and lastname
          if (this.firstname && this.lastname) {
            // console.log(`${this.firstname} ${this.lastname} both`);
            var filter = {
              firstname: { eq: this.firstname },
              lastname: { eq: this.lastname },
            };
            let e = await this.searchBooking(filter);
            eventIds.push(...e);
          } else {
            // Firstname only
            if (this.firstname && !this.lastname) {
              // console.log(`${this.firstname} firstname`);
              var filter = {
                firstname: { eq: this.firstname },
              };
              let e = await this.searchBooking(filter);
              eventIds.push(...e);
            }
            // Lastname only
            if (!this.firstname && this.lastname) {
              // console.log(`${this.lastname} lastname`);
              var filter = {
                lastname: { eq: this.lastname },
              };
              let e = await this.searchBooking(filter);
              eventIds.push(...e);
            }
          }
          // Email
          if (this.email) {
            // console.log(`${this.email} email`);
            var filter = {
              email: { eq: this.email },
            };
            let e = await this.searchBooking(filter);
            eventIds.push(...e);
          }
        }
        // Mobile
        if (this.mobile) {
          // console.log(`${this.mobile} phone`);
          var filter = {
            mobile: { eq: this.mobile },
          };
          let e = await this.searchBooking(filter);
          eventIds.push(...e);
        }
        eventIds = [...new Set(eventIds)];

        var getEventById = (id) => {
          return new Promise((resolve, reject) => {
            resolve(that.getEventById(id));
          });
        };

        var promises = eventIds.map(async (id) => {
          var result = await getEventById(id);
          return new Promise((res, rej) => {
            res(result);
          });
        });

        Promise.all(promises).then((results) => {
          // do what you want on the results
          that.events = results;
        });
      }
      this.loader = false;
    },
    async searchBookingBySearchField(searchQuery) {
      this.nextToken = null;
      let nextEvents;
      nextEvents = await this.nextSearchBookingBySearchField(searchQuery);
      while (this.nextToken !== null) {
        let e = await this.nextSearchBookingBySearchField(searchQuery);
        nextEvents.push(...nextEvents);
      }
      return nextEvents;
    },
    async nextSearchBookingBySearchField(searchQuery) {
      const bookingBySearchField = /* GraphQL */ `
        query BookingBySearchField(
          $searchField: String
          $sortDirection: ModelSortDirection
          $filter: ModelEventBookingFilterInput
          $limit: Int
          $nextToken: String
        ) {
          bookingBySearchField(
            searchField: $searchField
            sortDirection: $sortDirection
            filter: $filter
            limit: $limit
            nextToken: $nextToken
          ) {
            items {
              id
              firstname
              lastname
              email
              mobile
              attendance
              dob
              isDeleted
              eventSlot {
                id
                time
                type
                length
                booked
                eventSlotGroup {
                  room
                  date
                  eventLocation {
                    event {
                      id
                      iCalendar
                      type
                    }
                  }
                }
              }
            }
            nextToken
          }
        }
      `;

      const {
        data: { bookingBySearchField: events },
      } = await API.graphql({
        query: bookingBySearchField,
        variables: {
          searchField: searchQuery.toLowerCase(),
          nextToken: this.nextToken,
        },
      });

      this.nextToken = events.nextToken;

      const eventIds = events.items.map(
        (event) => event.eventSlot.eventSlotGroup.eventLocation.event.id
      );
      return eventIds;
    },
    async searchBooking(filter) {
      this.nextToken = null;
      let nextEvents;
      nextEvents = await this.nextSearchBooking(filter);
      while (this.nextToken !== null) {
        let e = await this.nextSearchBooking(filter);
        nextEvents.push(...e);
      }
      return nextEvents;
    },
    async nextSearchBooking(filter) {
      const listEventBookings = /* GraphQL */ `
        query ListEventBookings(
          $filter: ModelEventBookingFilterInput
          $limit: Int
          $nextToken: String
        ) {
          listEventBookings(
            filter: $filter
            limit: $limit
            nextToken: $nextToken
          ) {
            items {
              id
              firstname
              lastname
              email
              mobile
              dob
              customData
              createdAt
              startTime
              twentyFourHourReminder
              fortyEightHourReminder
              searchField
              isDeleted
              updatedAt
              eventSlot {
                id
                time
                length
                type
                booked
                isDeleted
                createdAt
                updatedAt
                eventSlotGroup {
                  room
                  date
                  eventLocation {
                    event {
                      id
                      iCalendar
                      type
                    }
                  }
                }
              }
            }
            nextToken
          }
        }
      `;

      const {
        data: { listEventBookings: events },
      } = await API.graphql({
        query: listEventBookings,
        variables: {
          filter,
          nextToken: this.nextToken,
        },
      });

      this.nextToken = events.nextToken;

      const eventIds = events.items.map(
        (event) => event.eventSlot.eventSlotGroup.eventLocation.event.id
      );
      return eventIds;
    },
  },
};
</script>
<style scoped>
.v-btn--open-dialog {
  top: 90px;
  position: fixed;
  margin: 0 0 16px 16px;
}
</style>